import { createLink, type LinkComponent } from "@tanstack/react-router";
import * as React from "react";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

type AnchorProps = React.ComponentPropsWithoutRef<"a">;

const AnchorLink = React.forwardRef<HTMLAnchorElement, AnchorProps>(
	(props, ref) => {
		return <a ref={ref} {...props} />;
	},
);
AnchorLink.displayName = "AnchorLink";

const CreatedLink = createLink(AnchorLink);

export const CustomLink: LinkComponent<typeof AnchorLink> = (props) => {
	return (
		<CreatedLink
			preload="intent"
			{...props}
			{...viewTransition(ViewTransitionTypes.FADE)}
		/>
	);
};
